import script from "./AiLocked.vue?vue&type=script&setup=true&lang=ts"
export * from "./AiLocked.vue?vue&type=script&setup=true&lang=ts"

import "./AiLocked.scss?vue&type=style&index=0&id=147225ca&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-147225ca"]])

export default __exports__